import { useQuery } from '@tanstack/react-query';
import fetchAPI from '../fetchAPI';

interface UseTwilioSrtTokensProps {
  from?: string | null;
  to?: string | null;
  billingAccountId?: string;
}

interface TwilioSrtCount {
  date: string;
  srtToken: number;
  callCount: number;
  smsCount: number;
  otherCount: number;
}

export const useTwilioSrtTokens = ({
  from,
  to,
  billingAccountId
}: UseTwilioSrtTokensProps) => {
  const queryParams = new URLSearchParams();
  if (from) queryParams.append('from', from);
  if (to) queryParams.append('to', to);
  if (billingAccountId) queryParams.append('billingAccountId', billingAccountId);

  const queryString = queryParams.toString();

  return useQuery({
    queryKey: ['srt-twilio', from, to, billingAccountId],
    queryFn: async () => {
      const response = await fetchAPI<{ message: string; data: TwilioSrtCount[] }>({
        method: 'GET',
        route: 'srt/twilio',
        queryString
      });
      return response;
    },
    enabled: !!from && !!to,
    // Analytics chart — see useAISrtTokens for rationale.
    staleTime: 10 * 60 * 1000
  });
};

export default useTwilioSrtTokens;
